export default "__VITE_ASSET__efe03470__"